import { configureStore as configureToolkitStore } from '@reduxjs/toolkit'
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import { createBrowserHistory } from 'history'
import { composeWithDevTools } from '@redux-devtools/extension'

import rootReducer from 'reducers'
import tokenWatcher from 'middleware/tokenWatcher'
import purgeOnLogoutMiddleware from 'middleware/purgeOnLogoutMiddleware'

export const history = createBrowserHistory()

const middleware = [tokenWatcher, purgeOnLogoutMiddleware]

const store = configureToolkitStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(middleware),
  devTools: composeWithDevTools
})

const persistor = persistStore(store)

export const configureStore = () => ({ persistor, store, history })

export default store
